<template>
  <!-- 二级导航 start -->
  <div class="bg-white" id="navtab">
    <ul class="nav nav-pills justify-content-between container" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          id="service-tab"
          data-toggle="tab"
          href="#service"
          role="tab"
          aria-controls="service"
          aria-selected="true"
          >企业综合服务</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="baijiu-tab"
          data-toggle="tab"
          href="#baijiu"
          role="tab"
          aria-controls="baijiu"
          aria-selected="false"
          >将门酒业</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="finance-tab"
          data-toggle="tab"
          href="#finance"
          role="tab"
          aria-controls="finance"
          aria-selected="false"
          >企业金融·保险</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="yanxuan-tab"
          data-toggle="tab"
          href="#yanxuan"
          role="tab"
          aria-controls="yanxuan"
          aria-selected="false"
          >特航严选</a
        >
      </li>
    </ul>
  </div>
  <!-- 二级导航 end -->

  <div class="tab-content">
    <div
      class="tab-pane fade show active"
      id="service"
      role="tabpanel"
      aria-labelledby="service-tab"
    >
      <!-- 企业综合服务 start -->
      <div class="py-lg">
        <div class="container">
          <div class="title">企业综合服务</div>
          <div class="service-introduction">
            当下企业盈利越来越难，除了扩大销量“开源”，也需要降低采购成本“节流”。特航企采服务旨在联合万家政企客户，向厂家集中采购，以企业综合采购报团方式降低所有客户的整体采购成本。目前特航企采已与众多品牌达成战略合作，享有相关商品的集团采购价格。欢迎更多企业采购加入特航打造的“万家企业消费联盟”平台。
          </div>
        </div>
      </div>
      <!-- 企业综合服务 end -->

      <!-- 主营业务 start -->
      <div class="main-business py-lg">
        <div class="container">
          <div class="title">主营业务</div>
          <div class="main-business-list">
            <img
              class="main-business-item"
              src="/images/service-main-business1.png"
              alt="礼品定制"
            />
            <img
              class="main-business-item"
              src="/images/service-main-business2.png"
              alt="企业酒水茶"
            />
            <img
              class="main-business-item"
              src="/images/service-main-business3.png"
              alt="企业福利"
            />
          </div>
          <div class="contact-title">品牌合作联系方式</div>
          <div class="contact-detail">
            <img class="contact-icon" src="/images/telephone.svg" alt="" />
            <span>联系人：张先生</span>
            <span style="margin-left: 20px">电话：13509698439</span>
          </div>
        </div>
      </div>

      <div class="bg-light main-business-m">
        <div class="container py-lg">
          <h2 class="title">主营业务</h2>
          <div id="businessResource" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
              <li data-target="#businessResource" data-slide-to="0" class="active"></li>
              <li data-target="#businessResource" data-slide-to="1"></li>
              <li data-target="#businessResource" data-slide-to="2"></li>
            </ol>
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  class="main-business-item"
                  src="/images/mobile/service-main-business-m1.png"
                  alt="礼品定制"
                />
              </div>
              <div class="carousel-item">
                <img
                  class="main-business-item"
                  src="/images/mobile/service-main-business-m2.png"
                  alt="企业酒水茶"
                />
              </div>
              <div class="carousel-item">
                <img
                  class="main-business-item"
                  src="/images/mobile/service-main-business-m3.png"
                  alt="企业福利"
                />
              </div>
            </div>
          </div>
          <div class="contact-title">品牌合作联系方式</div>
          <div class="contact-detail">
            <img class="contact-icon" src="/images/telephone.svg" alt="" />
            <span>联系人：张先生</span>
            <span style="margin-left: 20px">电话：13509698439</span>
          </div>
        </div>
      </div>
      <!-- 主营业务 end -->
    </div>
    <div class="tab-pane fade" id="baijiu" role="tabpanel" aria-labelledby="baijiu-tab">
      <!-- 将门酒业 start -->
      <div class="py-lg">
        <div class="container">
          <div class="title">将门酒业介绍</div>
          <div class="baijiu-introduction">
            特航旗下“将门酒业”公司，专注中高端白酒、红酒，以企业集采为依托，贵州国台、贵州习酒、钓鱼台、五粮液集团、泸州老窖集团、郎酒集团等各大酒厂及各区域经销商达成战略合作，能够向客户、合作伙伴提供低于市场价的产品，降低企业的采购成本。无论是企业招待、还是送礼、自饮，均能满足客户需求。
          </div>
        </div>
      </div>
      <!-- 将门酒业 end -->

      <!-- （将门酒业）主营品牌 start -->
      <div class="main-brand py-lg">
        <div class="container">
          <div class="title">主营品牌</div>
          <div class="main-brand-list">
            <div class="flex-box">
              <img class="main-brand-item" src="/images/service-baijiu1.png" alt="茅台" />
              <img class="main-brand-item" src="/images/service-baijiu2.png" alt="国台" />
              <img class="main-brand-item" src="/images/service-baijiu3.png" alt="钓鱼台" />
              <img class="main-brand-item" src="/images/service-baijiu4.png" alt="澳洲豹" />
              <img class="main-brand-item" src="/images/service-baijiu5.png" alt="郎酒" />
            </div>
            <div class="flex-box">
              <img class="main-brand-item" src="/images/service-baijiu6.png" alt="五粮液" />
              <img class="main-brand-item" src="/images/service-baijiu7.png" alt="习酒" />
              <img class="main-brand-item" src="/images/service-baijiu8.png" alt="贵州习酒" />
              <img class="main-brand-item" src="/images/service-baijiu9.png" alt="泸州老窖" />
            </div>
          </div>
          <div class="contact-detail">
            <img class="contact-icon" src="/images/telephone.svg" alt="电话图标" />
            <span>咨询电话：0755-88889999 转 9</span>
          </div>
        </div>
      </div>
      <!-- （将门酒业）主营品牌 end -->
    </div>
    <div class="tab-pane fade" id="finance" role="tabpanel" aria-labelledby="finance-tab">
      <!-- 企业金融·保险 start -->
      <div class="financ-insurance py-lg">
        <div class="container">
          <div class="title">企业金融·保险</div>
          <div class="finance-insurance-ad">
            <div class="finance-insurance-ad-text">
              <img src="/images/service-icon-point@2x.png" alt="" />
              <p>企业面临资金短缺？</p>
            </div>
            <div class="finance-insurance-ad-text">
              <img src="/images/service-icon-point@2x.png" alt="" />
              <p>还在买高价保险？</p>
            </div>
            <div class="finance-insurance-ad-text">
              <img src="/images/service-icon-point@2x.png" alt="" />
              <p>为您排忧解难，促进战略合作</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 企业金融·保险 end -->

      <!-- 业务介绍 start -->
      <div class="product-introduction py-lg bg-light">
        <div class="container">
          <div class="title">业务介绍</div>
          <div class="product-list">
            <div class="product-item">
              <img class="product-icon" src="/images/service-product1.png" alt="" />
              <div class="product-content">
                <p>保险：为企业保驾护航</p>
                <p>企业员工险、旅游险、企业财产意外险</p>
              </div>
              <div class="product-contact">
                <p>联系人：樊先生</p>
                <p>联系电话：13008826810</p>
              </div>
            </div>
            <div class="product-item">
              <img class="product-icon" src="/images/service-product2.png" alt="" />
              <div class="product-content">
                <p>金融：解决企业燃眉之急</p>
                <p>为企业员工、企业提供贷款服务、信用卡业务</p>
                <p>私人银行、证券开户</p>
              </div>
              <div class="product-contact">
                <p>联系人：贺小姐</p>
                <p>联系电话：13534006026</p>
              </div>
            </div>
            <div class="product-item">
              <img class="product-icon" src="/images/service-product3.png" alt="" />
              <div class="product-content">
                <p>保理：应收账款用于贷款</p>
                <p>不用资产抵押，用应收账款帮助企业贷款</p>
              </div>
              <div class="product-contact">
                <p>联系人：贺小姐</p>
                <p>联系电话：13534006026</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-light product-introduction-m">
        <div class="container py-lg">
          <h2 class="title">业务介绍</h2>
          <div id="productResource" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
              <li data-target="#productResource" data-slide-to="0" class="active"></li>
              <li data-target="#productResource" data-slide-to="1"></li>
              <li data-target="#productResource" data-slide-to="2"></li>
            </ol>
            `
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div class="product-item">
                  <img class="product-icon" src="/images/service-product1.png" alt="" />
                  <div class="product-content">
                    <p>保险：为企业保驾护航</p>
                    <p>企业员工险、旅游险、企业财产意外险</p>
                  </div>
                  <div class="product-contact">
                    <p>联系人：樊先生</p>
                    <p>联系电话：13008826810</p>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="product-item">
                  <img class="product-icon" src="/images/service-product2.png" alt="" />
                  <div class="product-content">
                    <p>金融：解决企业燃眉之急</p>
                    <p>为企业员工、企业提供贷款服务、信用卡业务</p>
                    <p>私人银行、证券开户</p>
                  </div>
                  <div class="product-contact">
                    <p>联系人：贺小姐</p>
                    <p>联系电话：13534006026</p>
                  </div>
                </div>
              </div>
              <div class="carousel-item">
                <div class="product-item">
                  <img class="product-icon" src="/images/service-product3.png" alt="" />
                  <div class="product-content">
                    <p>保理：应收账款用于贷款</p>
                    <p>不用资产抵押，用应收账款帮助企业贷款</p>
                  </div>
                  <div class="product-contact">
                    <p>联系人：贺小姐</p>
                    <p>联系电话：13534006026</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 业务介绍 end -->
    </div>
    <div class="tab-pane fade" id="yanxuan" role="tabpanel" aria-labelledby="yanxuan-tab">
      <!-- 严选介绍 start -->
      <div class="py-lg">
        <div class="container">
          <div class="title">特航严选介绍</div>
          <div class="yanxuan-miniapp-qrcode mb-4">
            <img
              class="mb-2"
              src="/images/mobile/miniapp.png"
              width="128"
              alt="特航严选小程序二维码"
            />
            <div>特航严选小程序二维码</div>
          </div>
          <div class="yanxuan-info">
            <div>
              2020年初，一场“新冠肺炎”使各行各业严重受创，整个市场经济不乐观，公司很多合作良好的客户也同步受到一定程度影响。作为特航航空的掌舵者——陈良均先生，坚信特航有合作二十年之久的庞大客户群体，又有专业的销售团队，于是和合作的一些大客户达成战略合作，协助大家一起共渡难关，互相成就。于是他亲自带队全国考察，到生产制造车间参观学习，经过严格的出厂把控，质量筛选，首批品牌合作商爱迪尔珠宝、海森梅尔，媛秀等陆续进入商场。2020年3月24日，特航严选正式上线。
            </div>
            <div>
              在这场战疫中，没有人是旁观者。特航的全体员工积极参与新的销售技能培训，学习新的营销方式，致力于将物美价廉的严选产品推广给更多需要的人。2020年5月20日，商城成功开启了第一场直播。渐渐地，商场也从0订单到最高日销售450单，小小的数据背后离不开团队的合作，也离不开合作伙伴的支持，更离不开客户对我们的信任。疫情只是暂时的，陪伴却是永远的。相信在特航人的共同努力下，会有更多优质的合作伙伴加入我们，会有更多的客户认可信赖我们。特航也定会不负所托，同大家一起创造共赢的未来。
            </div>
          </div>
        </div>
      </div>
      <!-- 严选介绍 end -->

      <!-- 严选合作 start -->
      <div class="py-lg bg-primary cooperation">
        <div class="container">
          <div class="title">品牌合作联系方式</div>
          <div class="yanxuan-contact-wrapper">
            <div class="contact-wrapper">
              <img class="mr-4" width="48" src="/images/tel-inline.png" alt="严选联系电话" />
              <span class="vertical-middle contact">电话：13824302040</span>
            </div>
            <div class="contact-wrapper">
              <img class="mr-4" width="48" src="/images/email.png" alt="严选联系邮箱" />
              <span class="vertical-middle contact">邮箱：hehongrong@tehang.com</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 严选合作 end -->

      <!-- 合作机构 start -->
      <div class="bg-white py-lg">
        <div class="container">
          <div class="title">合作机构</div>
          <div class="d-flex flex-wrap justify-content-between cop-row">
            <div class="partner">
              <img src="/images/ideal.svg" alt="Ideal爱迪尔珠宝" />
            </div>
            <div class="partner">
              <img src="/images/elegance.svg" alt="雅致" />
            </div>
            <div class="partner">
              <img src="/images/melado.svg" alt="" />
            </div>
            <div class="partner">
              <img src="/images/horsemen.svg" alt="海森梅尔" />
            </div>
          </div>
          <div class="d-flex flex-wrap justify-content-between cop-row">
            <div class="partner">
              <img src="/images/galanz.svg" alt="" />
            </div>
            <div class="partner">
              <img src="/images/ishow.svg" alt="ishow" />
            </div>
            <div class="partner">
              <img src="/images/facial-joy.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
      <!-- 合作机构 end -->
    </div>
  </div>
</template>
<script>
import $ from 'jquery'

export default {
  name: 'DesktopContent',
  setup() {
    $(document).ready(function () {
      const header = $('.header')[0].offsetHeight
      let bannerHeight = $('.banner')[0].offsetHeight
      const navtabHeight = $('#navtab').height()

      function layoutNavtab() {
        if (bannerHeight === 0) {
          bannerHeight = $('.banner')[0].offsetHeight
        }
        if ($(window).scrollTop() >= bannerHeight - navtabHeight - header - 10) {
          $('#navtab').addClass('navtab-fixed')
        } else {
          $('#navtab').removeClass('navtab-fixed')
        }
      }

      $(window).scroll(function (e) {
        changeHeader()
        layoutNavtab()
      })

      const $currentLinkItem = $('#navtab .nav-item')
      $currentLinkItem.click((e) => {
        $('#navtab .nav-pills').scrollLeft($(e.currentTarget)[0].offsetLeft - 50)
      })

      $('#navtab').on('shown.bs.tab', function (event) {
        $(window).scrollTop(bannerHeight - navtabHeight - header)
      })
    })
  },
}
</script>

<style lang="scss" scoped>
/* tab start */
.nav-pills {
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  background: #fff;
  padding: 0 15px;
}

.navtab-fixed {
  position: fixed;
  top: 75px;
  z-index: 199;
  width: 100%;
  min-width: 100%;
}

.nav-pills .nav-link {
  color: #333 !important;
}

.nav-pills .nav-link.active {
  position: relative;
  background: #fff !important;
}

.nav-pills .nav-link.active::after {
  position: absolute;
  content: ' ';
  display: block;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background-color: #4b7ef6;
  left: 0;
  bottom: 0;
}

.nav-pills .nav-item {
  flex: none;
}

.nav-pills .nav-link {
  padding: 23px 24px !important;
}
/* tab end */

/* service start */
#service {
  background-color: #f5f5f5;
}

.service-introduction {
  color: #666666;
  font-size: 18px;
  line-height: 32px;
}
/* service end */

/* mian-business start */
.main-business {
  text-align: center;
  background-color: #ffffff;
}

.main-business-list {
  display: flex;
  justify-content: center;
}

.main-business-item {
  width: 340px;
  margin: 0 24px;
}

.contact-title {
  font-size: 32px;
  line-height: 48px;
  margin-top: 74px;
  color: #333333;
}

.contact-detail {
  font-size: 24px;
  line-height: 36px;
  color: #666666;
  margin-top: 48px;
  font-weight: bold;
}

.contact-icon {
  margin-right: 20px;
  height: 36px;
}

.main-business-m {
  display: none;
  text-align: center;
}
/* mian-business end */

/* baijiu start */
#baijiu {
  background-color: #f5f5f5;
}

.baijiu-introduction {
  color: #666666;
  font-size: 18px;
  line-height: 32px;
}
/* baijiu end */

/* main-brand start */
.main-brand {
  background-color: #ffffff;
  text-align: center;
}

.main-brand-list {
  padding: 60px 0 40px;
}

.main-brand-list > .flex-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-brand-list > .flex-box:nth-child(1) > .main-brand-item {
  margin: 0 40px;
  height: 112px;
}

.main-brand-list > .flex-box:nth-child(2) {
  margin-top: 56px;
  flex-wrap: wrap;
}

.main-brand-list > .flex-box:nth-child(2) > .main-brand-item {
  margin: 0 22px;
  height: 85px;
}

/* main-brand end */

/* finance-insurance start */
.financ-insurance {
  background-color: #4b7ef6;
  text-align: center;
}

.financ-insurance .title {
  color: #ffffff;
}

.finance-insurance-ad {
  display: flex;
  justify-content: space-between;
  padding: 24px 0 50px;
  flex-wrap: wrap;
}

.finance-insurance-ad-text {
  color: #ffffff;
  font-size: 28px;
  line-height: 42px;
  margin: 0;
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.finance-insurance-ad-text img {
  height: 20px;
  margin-right: 18px;
}

.finance-insurance-ad-text p {
  margin: 0;
}

/* finance-insurance end */

/* product-introdution start */
.product-list {
  display: flex;
  justify-content: space-between;
}

.product-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-icon {
  width: 116px;
}

.product-content {
  margin-top: 44px;
  height: 108px;
  color: #666;
}

.product-contact {
  margin-top: 63px;
  color: #333;
}

.product-content p,
.product-contact p {
  font-size: 18px;
  line-height: 2;
  text-align: center;
  margin: 0;
}

.product-introduction-m {
  display: none;
}

@media (max-width: 768px) {
  .product-introduction {
    display: none;
  }

  .product-introduction-m {
    display: block;
  }

  .product-introduction-m .carousel-indicators {
    bottom: -48px;
  }

  .product-introduction-m .carousel-indicators .active {
    background-color: #4b7ef6;
  }

  .product-icon {
    width: 90px;
  }

  .product-content {
    height: 84px;
    margin-top: 32px;
  }

  .product-contact {
    margin-top: 10px;
  }

  .product-content p,
  .product-contact p {
    font-size: 14px;
    line-height: 2;
    text-align: center;
    margin: 0;
  }

  .product-contact p {
    font-weight: bold;
  }
}
/* product-introdution end */

.yanxuan-miniapp-qrcode {
  display: none;
  justify-content: center;
}

.yanxuan-info {
  color: #666666;
  font-size: 18px;
  line-height: 32px;
}

.partner img {
  height: 85px;
}

.cop-row {
  margin-bottom: 59px;
}

.cooperation .title {
  margin-bottom: 90px;
}

.yanxuan-contact-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 0 120px;
}

.yanxuan-contact-wrapper .contact {
  font-size: 26px;
}
</style>
